import { withInstall } from "@xplus/utils/with-install";
import divider from "./src/divider.vue";
export const xDivider = withInstall(divider);
export default xDivider;
export * from "./src/divider";
